import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/react/react/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../packages/react/src/Breadcrumbs/Breadcrumbs.docs.json';
import DeprecationBanner from '../components/DeprecationBanner';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ComponentProps = makeShortcode("ComponentProps");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <DeprecationBanner replacementUrl={'/components/breadcrumbs/react/latest'} mdxType="DeprecationBanner" />
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {Breadcrumbs} from '@primer/react'
`}</code></pre>
    <p>{`Breadcrumbs are used to show taxonomical context on pages that are many levels deep in a site’s hierarchy. Breadcrumbs show and link to parent, grandparent, and sometimes great-grandparent pages. Breadcrumbs are most appropriate on pages that:`}</p>
    <ul>
      <li parentName="ul">{`Are many levels deep on a site`}</li>
      <li parentName="ul">{`Do not have a section-level navigation`}</li>
      <li parentName="ul">{`May need the ability to quickly go back to the previous (parent) page`}</li>
    </ul>
    <h2>{`Examples`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Breadcrumbs>
  <Breadcrumbs.Item href="/">Home</Breadcrumbs.Item>
  <Breadcrumbs.Item href="/about">About</Breadcrumbs.Item>
  <Breadcrumbs.Item href="/about/team" selected>
    Team
  </Breadcrumbs.Item>
</Breadcrumbs>
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: false,
      fullTestCoverage: false,
      usedInProduction: true,
      usageExamplesDocumented: true,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      